import React, { useEffect, useState } from 'react';
import { DatePicker } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { DatePickerTypeV2 } from './types';
import InputLabel from '../Inputs/InputLabel';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DatePickerV2 = React.forwardRef<any, DatePickerTypeV2>(
  (
    {
      id,
      label,
      placeholder = 'Select...',
      disabled,
      required = false,
      readOnly,
      shape = 'squre',
      textColorClassName = 'text-textPrimary',
      bgColorClassName = 'bg-white',
      value,
      onChange,
      inputExtraClassNames,
      isError,
      fieldState,
      showTime = false,
      maxDate,
      minDate,
    }: DatePickerTypeV2,
    ref
  ) => {
    const [selectedDate, setDate] = useState<dayjs.Dayjs | null>(
      value ? dayjs(value) : null
    );
    const onSelect = (date: dayjs.Dayjs | null, dateString: string) => {
      setDate(date);

      onChange && onChange(date ? dayjs(date).toISOString() : '');
    };

    const { t } = useTranslation();

    useEffect(() => {
      setDate(value ? dayjs(value) : null);
    }, [value]);
    return (
      <div className="relative">
        {label && (
          <InputLabel text={label} name={id || ''} required={required} />
        )}
        <DatePicker
          ref={ref}
          className={`input focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 px-2 py-1 lg:py-2 align-middle cursor-pointer focus:ring-opacity-10 focus:ring-offset-0 ${
            shape === 'circle' ? 'rounded-full' : 'rounded-md'
          } ${bgColorClassName} ${textColorClassName} ${inputExtraClassNames}`}
          placeholder={
            t(`inputs.placeholders.${placeholder}`, placeholder || '') as string
          }
          showTime={showTime}
          name={id}
          onChange={onSelect}
          onOk={(t) => {
            onChange && onChange(dayjs(t).toISOString());
          }}
          value={selectedDate}
          disabledDate={(current) => {
            const max = maxDate ? dayjs(maxDate) : null;
            const min = minDate ? dayjs(minDate) : null;
            if (max && min) {
              return current > max || current < min;
            }
            if (max) {
              return current > max;
            }
            if (min) {
              return current < min;
            }
            return false;
          }}
        />
        {isError && (
          <div className="absolute top-[105%] right-0 text-[12px] text-red-500">
            <ReturnTranslatedText
              origintext={fieldState?.error?.message}
              text={`general.${fieldState?.error?.message}`}
            />
          </div>
        )}
      </div>
    );
  }
);

export default DatePickerV2;
